import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-options"
}
const _hoisted_3 = ["onClick"]

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSeedling, faBullseye, faBoxArchive, faGlassWater, faBan } from '@fortawesome/free-solid-svg-icons';

// ✅ Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'DishListSelector',
  props: {
    modelValue: {}
  },
  emits: ["list-change", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dropdownRef = ref<HTMLElement | null>(null);
const isOpen = ref(false);

const lists = [
  { id: 'current', label: 'Current Exposure', icon: faSeedling },
  { id: 'goals', label: 'Target Dishes', icon: faBullseye },
  { id: 'archived', label: 'Archived Dishes', icon: faBoxArchive },
  { id: 'safe', label: 'Safe Foods', icon: faGlassWater },
  { id: 'no-go', label: 'No-Go List', icon: faBan },
];

// ✅ Initialize selection with prop or fallback
const selectedValue = ref<string>(''); // Start blank, set in onMounted

const currentOption = computed(() => {
  return lists.find((l) => l.id === selectedValue.value) ?? lists[0];
});

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function selectOption(id: string) {
  selectedValue.value = id;
  emit('list-change', id);
  emit('update:modelValue', id); // Optional if using v-model
  isOpen.value = false;
}

function handleClickOutside(event: MouseEvent) {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);

  // ✅ Initialize with prop if valid, else fallback
  if (props.modelValue && lists.some(l => l.id === props.modelValue)) {
    selectedValue.value = props.modelValue;
  } else {
    selectedValue.value = lists[0].id;
    emit('list-change', selectedValue.value); // Ensure parent knows the fallback
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown-container",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "dropdown-selected",
        onClick: toggleDropdown
      }, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: currentOption.value.icon
        }, null, 8, ["icon"]),
        _createElementVNode("span", null, _toDisplayString(currentOption.value.label), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["dropdown-arrow", { open: isOpen.value }])
        }, "▾", 2)
      ]),
      _createVNode(_Transition, { name: "dropdown-fade" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(lists, (option) => {
                  return _createElementVNode("li", {
                    key: option.id,
                    class: "dropdown-option",
                    onClick: ($event: any) => (selectOption(option.id))
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: option.icon
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(option.label), 1)
                  ], 8, _hoisted_3)
                }), 64))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 512))
}
}

})